import { FC } from 'react'

import { DotBadge, LabelBadgeV2 } from 'ui/components'

import { ChangesProps } from './ChangesProps'

import * as SC from './styles'

export const Changes: FC<ChangesProps> = ({ data: { to, label, from } }) => (
  <LabelBadgeV2>
    {to === '' ? (
      <>
        <DotBadge color="error" />
        {label}: <SC.OldValue>'{from}'</SC.OldValue> → <SC.NewValueRed>'—'</SC.NewValueRed>
      </>
    ) : (
      <>
        <DotBadge color="default" />
        {label}: <SC.OldValue>'{from}'</SC.OldValue> → <SC.NewValueGreen>'{to}'</SC.NewValueGreen>
      </>
    )}
  </LabelBadgeV2>
)
